import i18n from '../i18n';

/**
 * Translate display text through the `ui` namespace. Key = text reduced to lower-case
 * alphanumerics (same rule as the web app), edge punctuation/spacing is preserved, and
 * English or unknown text is returned unchanged.
 */
export function translateText(text: string): string {
  const lang = (i18n.language || 'en').split('-')[0];
  if (lang === 'en' || typeof text !== 'string') return text;
  const m = text.match(/^([^\p{L}\p{N}\p{M}]*)([\s\S]*?)([^\p{L}\p{N}\p{M}]*)$/u);
  if (!m || !m[2]) return text;
  const [, lead, core, trail] = m;
  const flat = core.replace(/\s+/g, ' ');
  const key = flat.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  if (!key || key.length > 120) return text;
  const out = i18n.t(key, { ns: 'ui', defaultValue: flat }) as string;
  if (!out || out === flat) return text;
  const bare = out.replace(/^[^\p{L}\p{N}\p{M}]+|[^\p{L}\p{N}\p{M}]+$/gu, '');
  return lead + (bare || out) + trail;
}
export const tp = translateText;
